




















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { Sort, Option, WatchOption } from '@/services/data'
import draggable from 'vuedraggable'
import utility from '@/common/utility'
import OptionSearch from '@/components/OptionSearch.vue'
import NumberRowEditor from '@/components/NumberRowEditor.vue'
import SymbolName from '@/components/SymbolName.vue'

@Component({
  components: {
    draggable,
    OptionSearch,
    NumberRowEditor,
    SymbolName
  }
})
export default class WatchOptions extends Vue {
  name = 'WatchOptions'
  @Prop() Items: WatchOption[]
  @Prop() Keys: string[]
  @Prop() IsRead: boolean
  @Prop() IsSystem: boolean
  @Prop() draggable: boolean
  showSymbolSearch = false
  sort: Sort = { key: null, direction: null }
  currentOption: WatchOption

  $num (num: number): string {
    if (num != null && num !== undefined) {
      return num.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
    }
    return null
  }

  $fix (num: number, end?: string): string {
    if (num != null && num !== undefined) {
      return num.toFixed(2) + (end || '')
    }
    return null
  }

  sortItems (key: string, direction: string) {
    this.sort = { key, direction }
    const sort = (a: WatchOption, b: WatchOption): number => {
      const v = direction === 'Asc' ? 1 : -1
      const left = this.getByKey(a, key)
      const right = this.getByKey(b, key)
      if (left === right) return 0
      return left > right ? v : v * -1
    }
    if (sort) {
      this.Items.sort(sort)
    }
  }

  getByKey = utility.getByKey

  @Emit('dragEnd')
  async dragEnd () {
    for (let i = 0; i < this.Items.length; i++) {
      // this.Items[i].Rank = i + 1
    }
  }

  @Emit('addOption')
  async addOption (item: Option) {
    if (item == null) return
    this.showSymbolSearch = false
    return item
  }

  @Emit('deleteOption')
  delItem (item: WatchOption) {
    return item
  }
}
